import React from 'react';

import BotaoLink from 'Component/BotaoLink';
import Icone from 'Component/Icone';

interface Props {
    carregando: boolean;
    registros?: number;
    redirecionar?: string;
}

const SemRegistros = ({ carregando, registros = 0, redirecionar }: Props): React.ReactElement =>
{
    return (
        <React.Fragment>
            { !carregando && !registros && (
                <div className="d-flex flex-column flex-grow-1 justify-content-center align-items-center">
                    <Icone nome="emoji-frown" className="fs-1" />
                    <p className="h1">
                        Nenhum registro encontrado
                    </p>
                    { redirecionar && (
                        <React.Fragment>
                            <p className="lead">
                                Clique no botão abaixo para adicionar um novo registro!
                            </p>
                            <BotaoLink
                                tema="success"
                                icone="plus-lg"
                                to={ redirecionar }
                            >
                                Adicionar
                            </BotaoLink>
                        </React.Fragment>
                    ) }
                </div>
            ) }
        </React.Fragment>
    )
}

export default SemRegistros;
